import { Injectable } from '@angular/core';
import { UserRole, UserStatus } from '../../../domain/user/user-enums';

@Injectable({
  providedIn: 'root',
})
export class UserUiService {

  getUserRoleString(role: UserRole): string {
    switch (role) {
      case UserRole.ADMIN:
        return 'Administrador';
      case UserRole.GESTOR:
        return 'Gestor';
      case UserRole.USER:
        return 'Usuario';
      case UserRole.INTERNAL:
      default:
        return 'Usuario Interno';

    }
  }

  getUserStatusString(status: UserStatus): string {
    switch (status) {
      case UserStatus.ACTIVE:
        return 'Activo';
      case UserStatus.INACTIVE:
        return 'Inactivo';
      case UserStatus.PENDING:
        return 'Pendiente';
      case UserStatus.EXPIRED:
        return 'Expirado';
      default:
        return 'Pendiente';
    }
  }

  getUserRoleBadgeClass(role: UserRole): string {
    switch (role) {
      case UserRole.ADMIN:
        return 'bg-purple-50 text-purple-700 dark:bg-purple-500/15 dark:text-purple-400';
      case UserRole.GESTOR:
        return 'bg-blue-50 text-blue-700 dark:bg-blue-500/15 dark:text-blue-400';
      case UserRole.USER:
        return 'bg-green-100 text-green-700 dark:bg-white/10 dark:text-gray-300';
      case UserRole.INTERNAL:
      default:
        return 'bg-gray-50 text-gray-700 dark:bg-green-500/15 dark:text-green-500';
    }
  }

  getUserStatusBadgeClass(status: UserStatus): string {
    switch (status) {
      case UserStatus.ACTIVE:
        return 'bg-green-50 text-green-700 dark:bg-green-500/15 dark:text-green-500';
      case UserStatus.INACTIVE:
        return 'bg-gray-100 text-gray-700 dark:bg-white/10 dark:text-gray-300';
      case UserStatus.EXPIRED:
        return 'bg-red-50 text-red-700 dark:bg-red-500/15 dark:text-red-500';
      case UserStatus.PENDING:
      default:
        return 'bg-yellow-50 text-yellow-700 dark:bg-yellow-500/15 dark:text-yellow-400';
    }
  }

  getUserIsEmailValidBadgeClass(): string {
    return 'bg-yellow-100 text-yellow-800';
  }
}
